import useSWR from 'swr';
import api from '../utils/api';

const fetcher = async (url: string) => {
  const { data } = await api.get(url);

  // Handle different possible response structures
  const c2paData = data.c2Pa || data.c2pa || data;
  
  const assertions = c2paData?.assertions || [];
  const claimGeneratorInfo = c2paData?.claim_generator_info || [];
  const c2paActions = assertions.find(assertion => 
    assertion.label === 'c2pa.actions' || 
    assertion.label === 'actions' ||
    assertion.type === 'c2pa.actions'
  ) || {};
  
  const actions = c2paActions.data?.actions || c2paActions.actions || [];
  
  // Find created action - check for both 'c2pa.created' and potentially other action types
  let createdAction = actions.find(action => 
    action.action === 'c2pa.created' || 
    action.action === 'created' ||
    action.type === 'c2pa.created'
  ) || {};
  
  // If no created action found, try to find any action that might have tool information
  if (!createdAction || Object.keys(createdAction).length === 0) {
    createdAction = actions.find(action => 
      action.softwareAgent?.name || 
      action.parameters?.ModelName ||
      action.parameters?.modelName ||
      action.tool?.name
    ) || {};
  }

  // Try multiple paths to get the AI tool/model name
  const aiToolName = 
    createdAction?.softwareAgent?.name ||
    createdAction?.softwareAgent?.identifier ||
    createdAction?.tool?.name ||
    createdAction?.parameters?.ModelName ||
    createdAction?.parameters?.modelName ||
    createdAction?.parameters?.ToolName ||
    createdAction?.parameters?.toolName ||
    createdAction?.parameters?.Model ||
    createdAction?.parameters?.model ||
    data?.modelName ||
    data?.model_name ||
    c2paData?.modelName ||
    'Unknown';

  // Try multiple paths to get the app/issuer name
  const issuerName = 
    claimGeneratorInfo[0]?.name ||
    claimGeneratorInfo[0]?.identifier ||
    data?.issuer ||
    data?.app ||
    c2paData?.issuer ||
    c2paData?.app ||
    'Unknown';

  return {
    Issued_By: issuerName,
    created: aiToolName,
    signature: c2paData?.assertion?.[0]?.data?.[0]?.signature || data?.signature || '',
    app: issuerName,
    verified: data?.verified || c2paData?.verified || false,
    status: data?.status || c2paData?.status || 'Unknown',
    artStyleName: createdAction?.parameters?.ModelName || createdAction?.parameters?.modelName || createdAction?.parameters?.ArtStyleName,
    artStyleCreator: createdAction?.parameters?.ModelCreatorName || createdAction?.parameters?.modelCreatorName || createdAction?.parameters?.ArtStyleCreator,
    creator: createdAction?.parameters?.CreatorName || createdAction?.parameters?.creatorName || createdAction?.parameters?.Creator,
    LicenseBegins: createdAction?.parameters?.LicenseBegins || createdAction?.parameters?.licenseBegins,
    LicenseEnds: createdAction?.parameters?.LicenseEnds || createdAction?.parameters?.licenseEnds,
    influencerName : createdAction?.parameters?.InfluencerName || createdAction?.parameters?.influencerName,
  };
};

const useC2PA = (imageId: string | null | undefined, skipCall: boolean = false) => {
  // If skipCall is true or imageId is falsy, don't make the API call
  const shouldSkip = skipCall || !imageId;
  const { data, error, isLoading } = useSWR(
    shouldSkip ? null : `/image-generation/v1/images/${imageId}/c2pa`,
    fetcher, {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      dedupingInterval: 60000
    }
  );

  return { C2PAImageDate: data, error, isLoading };
};

export default useC2PA;